import { render, staticRenderFns } from "./ExpertsList.vue?vue&type=template&id=e31061a8"
import script from "./ExpertsList.vue?vue&type=script&lang=js"
export * from "./ExpertsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/honeypot.learningsystem.de/releases/20260624084000/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e31061a8')) {
      api.createRecord('e31061a8', component.options)
    } else {
      api.reload('e31061a8', component.options)
    }
    module.hot.accept("./ExpertsList.vue?vue&type=template&id=e31061a8", function () {
      api.rerender('e31061a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ExpertsList.vue"
export default component.exports